var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 0.5C1.28245 0.5 0.5 1.28245 0.5 2.25C0.5 3.21755 1.28245 4 2.25 4H17.25C18.2175 4 19 3.21755 19 2.25C19 1.28245 18.2175 0.5 17.25 0.5H2.25ZM4.75 6.75C3.78245 6.75 3 7.53245 3 8.5C3 9.46755 3.78245 10.25 4.75 10.25H19.75C20.7175 10.25 21.5 9.46755 21.5 8.5C21.5 7.53245 20.7175 6.75 19.75 6.75H4.75ZM17.25 16.5C18.2175 16.5 19 15.7175 19 14.75C19 13.7825 18.2175 13 17.25 13H2.25C1.28245 13 0.5 13.7825 0.5 14.75C0.5 15.7175 1.28245 16.5 2.25 16.5H17.25Z",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeed);
export default __webpack_public_path__ + "static/media/feed.2027fdaee0f3ad27e4e07665355152f0.svg";
export { ForwardRef as ReactComponent };